// @flow
import NotEnoughBalanceModalContainer from './NotEnoughBalanceModalContainer'
export default NotEnoughBalanceModalContainer
